import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class RoutingStateService {
  private history: any[] = [];

  constructor(private router: Router) { }

  public loadRouting(): void {
    this.router.events.pipe(filter((event: any) => event instanceof NavigationEnd)).subscribe(({ urlAfterRedirects }: NavigationEnd) => {
      if (!urlAfterRedirects.includes('/load')) {
        this.history = [...this.history, urlAfterRedirects];
      }
    });
  }

  public addElem(nav: any) {
    this.history = [...this.history, nav];
  }

  public getHistory(): string[] {
    return this.history;
  }

  public getPreviousUrl(): string {
    return this.history[this.history.length - 2] || '/index';
  }
}
